export const socketIOAddress = process.env.NODE_ENV === "development"
    ? 'ws://127.0.0.1:9501/'
    : "wss://qyh-next-server.zhang66.cn/"


// WEBPACK FOOTER //
// ./src/config/socketIOAddress.js